<template>
  <span class="go-back d-flex align-center">
    <v-btn icon @click="goBack">
     <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
  </span>
</template>

<script>
export default {
  methods: {
    goBack() {
      return this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.go-back {
  display: flex;
  cursor: pointer;
}
button {
  border: 0;
}
</style>